import { default as Icon, IconProps } from 'interface/Icon';

const icon = (props: IconProps) => <Icon icon="petbattle_speed" {...props} />;
export default icon;
